import { jsx as _jsx } from "react/jsx-runtime";
import { ReactComponent as WalletIcon } from '../../../assets/icons/sharedIcons/wallet.svg';
import { ReactComponent as AdaBigIcon } from '../../../assets/icons/sharedIcons/icon-ada-big.svg';
import { ReactComponent as BellIcon } from '../../../assets/icons/sharedIcons/bell.svg';
import { ReactComponent as UserIcon } from '../../../assets/icons/sharedIcons/user.svg';
import { ReactComponent as MessagesIcon } from '../../../assets/icons/sharedIcons/messages.svg';
export const awardIcons = [
    {
        name: 'wallet',
        icon: _jsx(WalletIcon, {})
    },
    {
        name: 'ada-big',
        icon: _jsx(AdaBigIcon, {})
    }
];
export const profileIcons = [
    {
        name: 'bell',
        icon: _jsx(BellIcon, {})
    },
    {
        name: 'user',
        icon: _jsx(UserIcon, {}),
        parent: '/my_account'
    },
    {
        name: 'messages',
        icon: _jsx(MessagesIcon, {})
    }
];
